import { put, select } from 'redux-saga/effects'
import { takeLatest } from '@redux-saga/core/effects'
import { getQuickActionsSelector } from '../selectors/quickActions.selector'
import { saveWoundCare } from '../../procedures/woundCare/store/woundCare.actions'
import { QuickActionsConstants } from '../store/quickActions.constants'

export function* setWoundCareQuickActionTimeLineRow() {
  const quickActionsObject = yield select(getQuickActionsSelector)
  const { addWoundCareToTimeline } = quickActionsObject
  if (addWoundCareToTimeline) {
    yield put(saveWoundCare())
  }
}

export function* setWoundCareQuickActionTimeLineRowSaga() {
  yield takeLatest([QuickActionsConstants.SET_ADD_WOUND_CARE_TO_TIMELINE], setWoundCareQuickActionTimeLineRow)
}
